import { render } from "./OrdersHistoryOrderProduct.vue?vue&type=template&id=645701dc"
import script from "./OrdersHistoryOrderProduct.vue?vue&type=script&lang=js"
export * from "./OrdersHistoryOrderProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__